import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CookieName } from "../utils/CookieName";
import Cookies from "js-cookie";
export const api = createApi({
  reducerPath: "api",

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,

    prepareHeaders: (headers, { getState }) => {
      //   const token = getState().auth.token;

      //   if (token) {
      //     headers.set("Authorization", `Bearer ${token}`);
      //   }

      const token = Cookies.get(CookieName);

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),

  // tagTypes: ["Auth", "Categories", "HomeBanner", "App_Setup"],
  tagTypes: [],
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
});
